import { ReactNode } from 'react'
import cn from 'classnames'

export const Button = ({
  className,
  selected,
  disabled = false,
  onClick,
  children
}: {
  className?: string
  selected?: boolean
  disabled?: boolean
  onClick?: () => void
  children: ReactNode
}) => {
  const selectedClass = 'bg-[#D7D2CB]'

  return (
    <button
      onClick={onClick}
      className={cn(className, 'uppercase text-sm disabled:opacity-50 disabled:cursor-not-allowed', selected && selectedClass)}
      disabled={disabled}
    >
      {children}
    </button>
  )
}
